<template>
  <div class="map-root select-none">
    <div ref="map-mapview" class="map"></div>
    <div class="global-loading">
      <table>
        <tr>
          <td>
            <span class="global-loading-text" v-html="loadingText"></span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {
    MapKey: {
      required: true,
      type: String,
    },
    MapLayers: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      loadingText: "加载中...",
      mapInstance: null,
    };
  },
  methods: {
    layerButtonClick: function (data) {
      this.$emit("layerButtonClick",data);
    },
  },
  created() {
    console.debug("mapview created");
  },
  mounted() {
    // 创建地图，并通过样式让地图填满窗口
    let that = this;
    let mapkey = this.MapKey;

    var mapConfigs = {};
    if (this.MapLayers) {
      mapConfigs["mapLayers"] = this.MapLayers;
    }

    this.$nextTick(function () {
      // 不传入 syscode 和 key ，或者值为空时，
      // zjumap 插件自动从 URL 地址
      // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
      // 中读取 syscode 和 key 的值。
      // eslint-disable-next-line no-undef
      $(that.$refs["map-mapview"]).zjumap({
        syscode: "ZJMap",
        key: mapkey,
        loading: ".global-loading",
        loadingText: ".global-loading-text",
        //地图配置
        // eslint-disable-next-line no-undef
        mapConfigs: $.extend(
          {},
          {
            //mapStyle: "styles/darknight.json",
            //toggleTool: "tool/Toggle",
            //tilesPath: "/lib/zjmap/Content/tiles/tiles",
            //zoom:16,
            //mapVender: that.MapVender,
            // mapLayers: "观光车,游船",
            // minZoom: 5, //允许的最小地图级别
            // maxZoom: 19, //允许的最大地图级别
            // zoom: 15, //默认地图级别
            // layerDefineFile: "js/layers-default.js", //图层定义文件
            // mapType: "BMAP_NOAMAL_MAP",
            // center: [106.904337, 32.957395],
            //tilt: 0,
            onMapCreated: function (e) {
              that.mapInstance = e.map;
              that.center = e.map.config.center;
              //that.addDom();
            },
            onLayerButtonClick: function (e) {
              var item = e.originEvent.currentTarget;
              // eslint-disable-next-line no-undef
              var action = $(item).data("action");
              var data = {
                e:e,
                action: action,
              };
              that.layerButtonClick(data);
            },
          },
          mapConfigs
        ),
        //,gotMapConfigs: function (conf, opts) { } //当从统一配置中获取到地图配置，并合并完 mapConfigs 后，触发此事件。
      });
    });
  },
  beforeDestroy() {
    if (this.mapInstance) {
      this.mapInstance.destroy();
      this.mapInstance = null;
      console.debug("mapview beforeDestroy");
    }
  },
  destroyed() {},
};
</script>

<style scoped>
.map {
  border-radius: 20px;
}
</style>